import * as types from './types'

export function setPage(page){
  return {
    type: types.SET_PAGE,
    payload:page
  }
}



// WEBPACK FOOTER //
// ./src/actions/navigation.js